(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ecCom"), require("antd"), require("mobx"), require("mobxReact"), require("comsMobx"), require("ReactDOM"), require("ReactRouter"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ecCom", "antd", "mobx", "mobxReact", "comsMobx", "ReactDOM", "ReactRouter"], factory);
	else if(typeof exports === 'object')
		exports["weaPortalPublic"] = factory(require("React"), require("ecCom"), require("antd"), require("mobx"), require("mobxReact"), require("comsMobx"), require("ReactDOM"), require("ReactRouter"));
	else
		root["weaPortalPublic"] = factory(root["React"], root["ecCom"], root["antd"], root["mobx"], root["mobxReact"], root["comsMobx"], root["ReactDOM"], root["ReactRouter"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_49__, __WEBPACK_EXTERNAL_MODULE_54__, __WEBPACK_EXTERNAL_MODULE_76__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition